/**
 * Converts a string into a URL-friendly slug.
 *
 * @param {string} str - The string to be slugified.
 * @returns {string} - The slugified string.
 */
import slugify from 'slugify';

export default (str: string) => slugify(str, { lower: true, strict: true });
